"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const main_frame_1 = require("./main/main-frame");
(0, main_frame_1.define)('main-frame');
